import { render } from "./DisplayModeKeyCard.vue?vue&type=template&id=65c13485&scoped=true"
import script from "./DisplayModeKeyCard.vue?vue&type=script&lang=js"
export * from "./DisplayModeKeyCard.vue?vue&type=script&lang=js"

import "./DisplayModeKeyCard.vue?vue&type=style&index=0&id=65c13485&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c13485"]])

export default __exports__